import { collection_url_cookie } from '@scripts/utils';
import Alpine from 'alpinejs';

Alpine.data('PpsSchool', () => ({
  loading: false,
  hasErrors: false,
  hasAccess: true,

  form: {
    code: '',
  },
  handleSubmit: async function (e: Event) {
    e.preventDefault();
    this.hasErrors = false;
    this.loading = true;
    this.hasAccess = true;

    try {
      if (window.theme.parentPaymentSystem !== 'new') {
        const response = await fetch(`/apps/acidgreen/parent_payment/${this.form.code}`);
        const json = await response.json();
        if (!response.ok || (json && json.status === 'fail')) {
          this.hasErrors = true;
          this.loading = false;
          return;
        }
        const url = `/collections/${json.handle}`;
        collection_url_cookie(url);
        window.location.href = url;
      } else {
        const parentPaymentCode = this.form.code.trim().toUpperCase();

        if (parentPaymentCode.length > 8) {
          this.hasErrors = true;
          this.loading = false;
          return;
        }

        const parentPaymentLink = `/pages/parent-payment/${parentPaymentCode}`;

        // We fetch and check that the page exits before redirecting:
        const result = await fetch(parentPaymentLink);

        if (!result.ok) {
          this.hasErrors = true;
          this.loading = false;
          return;
        }

        window.location.href = parentPaymentLink;
      }
    } catch (e) {
      this.hasErrors = true;
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },
}));
